import { render, staticRenderFns } from "./TriggerHistoryDetails.vue?vue&type=template&id=006134a4"
import script from "./TriggerHistoryDetails.vue?vue&type=script&lang=js"
export * from "./TriggerHistoryDetails.vue?vue&type=script&lang=js"
import style0 from "./TriggerHistoryDetails.vue?vue&type=style&index=0&id=006134a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports